const middleware = {}

middleware['checkPreindexLink'] = require('../../middleware/checkPreindexLink.js')
middleware['checkPreindexLink'] = middleware['checkPreindexLink'].default || middleware['checkPreindexLink']

export default middleware
